import React from 'react';
import ChatShell from './components/ChatShell';

/**
 * Thin route entry for `/chatbot`. The full-page chat surface. The floating
 * <BubbleShell> lives on the dashboard pages (POC + COO) — not here, because
 * it'd be redundant to layer a bubble on top of the full-page chat.
 *
 * All chat UI lives in <ChatShell>, which is layout-agnostic — the same
 * component composes inside <BubbleShell> for the widget port. Keep this
 * file skinny; do not add UI here.
 */
export default function ChatbotPage() {
  return (
    <div data-drishti="page" className="min-h-screen bg-app-bg text-slate-700">
      <ChatShell layout="page" />
    </div>
  );
}
